import PatientFileUploadModel from '@/Models/PatientFileUploadModel';

/**
 * Maps PatientFileUpload to backend dto
 * @param {PatientFileUploadModel} patientFileUpload
 * @returns {object}
 */
export const PatientFileUploadRequest = patientFileUpload => {
  const newPatientFileUpload = JSON.parse(JSON.stringify(patientFileUpload));
  delete newPatientFileUpload.Id;
  return newPatientFileUpload;
};
